import { useMutation } from 'react-query';
import axiosClient from './axios';

const getCategories = async ({ page = 1, limit = 10, search = '' }: { page?: number; limit?: number; search?: string }) => {
  try {
    let qr = `?page=${page}&limit=${limit}`

    if (search && search !== '') {
      qr += `&search=${search}`
    }

    return axiosClient.get(`/v1/category/getCategories${qr}`);
  } catch (error) { }
}

const useAddCategory = () => {
  return useMutation(
    (payload: any) => axiosClient.post('/v1/category', payload));
};

const useUpdateCategory = () => {
  return useMutation(
    (payload: any) => axiosClient.put('/v1/category', payload));
};

export {
  getCategories,
  useAddCategory,
  useUpdateCategory
};
